import { put, takeLatest } from 'redux-saga/effects'
import { confirmInvitation as confirm } from '../api/acceptInvitationConfirm'
import {
  acceptInvitationSucceeded,
  acceptInvitationFailed
} from '../../actions/acceptInvitation'
import { ACCEPT_INVITATION_CONFIRM } from '../../constants/action.types'
import executeSaga from './helpers/executeSaga'

export function* confirmInvitation({ request }, action) {
  const {
    invitationToken,
    password,
    passwordConfirmation,
    recaptchaResponse
  } = action.payload

  const data = {
    token: invitationToken,
    user_password: password,
    user_password_confirmation: passwordConfirmation,
    'g-recaptcha-response': recaptchaResponse
  }

  yield executeSaga(
    request,
    data,
    result => put(acceptInvitationSucceeded({ isUserActive: !!result.active })),
    error => put(acceptInvitationFailed({ confirmationError: error.message }))
  )
}

export default function*({ request } = { request: confirm }) {
  yield takeLatest(ACCEPT_INVITATION_CONFIRM, confirmInvitation, { request })
}
